module.exports = __webpack_public_path__ + "img/bannow_big.75d23fa5.png";